module.exports = __webpack_public_path__ + "img/20210625_Teilkauf_2893.ecf16d69.png";